// extracted by mini-css-extract-plugin
export default {"tags":"tags_tags__aNRmB","tag":"tags_tag__BClNz","icon":"tags_icon__ipN9Y"};